import { ThisReceiver } from '@angular/compiler';
import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appIcon]'
})
export class IconDirective implements OnInit, OnChanges {

  @Input() public solid:   any;
  @Input() public light:   any;
  @Input() public thin:    any;
  @Input() public duotone: any;

  @Input()
  public size: 'xs' |
               '2xs' |
               'sm' |
               'md' |
               'lg' |
               'xl' |
               '2xl' = 'md'

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnChanges(): void {
    this.ngOnInit();
  }

  ngOnInit(): void {
    // this.el.nativeElement.ariaHidden = 'true';
    if (this.el.nativeElement instanceof HTMLImageElement) {
      this.startWithImage();
    } else {
      this.startWithFontAwesome();
    }

  }

  private startWithImage() {
    const sizes = {
      'xs': 4,
      '2xs': 8,
      'sm': 16,
      'md': 24,
      'lg': 40,
      'xl': 64
    }
    if (this.el.nativeElement instanceof HTMLImageElement) {
      this.el.nativeElement.width = sizes[this.size];
      this.el.nativeElement.height = sizes[this.size];
    }
  }

  private startWithFontAwesome() {
    let type = 'regular'
    for (const key of ['solid', 'light', 'thin', 'duotone']) {
      if (this[key] || this[key] === '') {
        type = key;
        break;
      }
    }
    const icon = this.el.nativeElement.innerText;
    this.el.nativeElement.innerHTML = '';
    this.el.nativeElement.classList.add(
      'fa-' + type,
      'fa-' + icon,
      'fa-' + this.size
    );
  }

}
